import React from 'react';
import { useClassNameMapper } from 'react-bootstrap';
import GuideNavigation from '../../../guides/GuideNavigation/GuideNavigation';
import ManuallyOrderedArticleNavigation from '../../../guides/ManuallyOrderedArticleNavigation/ManuallyOrderedArticleNavigation';
import { NavigationType } from '../useGuideNavigationForArticle';
import type { GuideContentArticle } from '@aurora/shared-generated/types/graphql-schema-types';

/**
 * Props for the KbArticleGuideNavigation component.
 */
interface Props {
  /**
   * class for the link
   */
  className?: string;
  /**
   * The type of navigation being used.
   */
  navigationType: NavigationType;
  /**
   * Associated chapters or guide for an article (for guideNavigation )
   */
  guideContentArticle: GuideContentArticle;
}

/**
 * KbArticleGuideNavigation component
 *
 * @author Amit Agrawal
 */
const KbArticleGuideNavigation: React.FC<Props> = ({
  className,
  navigationType,
  guideContentArticle
}) => {
  const cx = useClassNameMapper();

  return (
    <>
      {navigationType === NavigationType.GUIDE_NAVIGATION && (
        <GuideNavigation
          className={cx(className)}
          guideContentArticle={guideContentArticle as GuideContentArticle}
        />
      )}
      {navigationType === NavigationType.MANUALLY_SORTED_NAVIGATION && (
        <ManuallyOrderedArticleNavigation className={cx(className)} />
      )}
    </>
  );
};

export default KbArticleGuideNavigation;
